import React, { Component } from 'react';
import "./style.css"
import { Grid,Box,Tabs,Tab } from '@mui/material';
import BreadcrumbComp from '../CommonComponents/Breadcrumb/Breadcrumb';
import { getEmployeeDetail } from '../../services/employeeService';
import { toastAlert } from '../../helpers/toastAlert';
import { withRouter } from 'react-router-dom';
import ProfileCard from '../CommonComponents/ProfileCard';
import ActivityLog from '../CommonComponents/ActivityLog';
import DocumentList from '../CommonComponents/DocumentList';
import { connect } from 'react-redux';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import FolderIcon from '@mui/icons-material/Folder';

class EmployeeDetailComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            editEmployee: false,
            error: [],
            tabValue: 0,

            // Edit employee values
            editModel: false,
            editError: [],
            editName: "",
            editEmail: "",
            editMobile: "",
            editDepartment: "",
        }
    }

    

    getEmployeeData = async () => {
        try {
            console.log('getEmployeeData : Id : ', this.props.match.params.id);
            var employeeData = await getEmployeeDetail({ employeeId: this.props.match.params.id }, this.props);
            if (employeeData && employeeData?.code == 200 || employeeData?.code == 200  ) {
                this.setState({
                    data: employeeData.data,
                    loading: false,
                })
            } else {
                // error
                console.log('error vendor details : ', employeeData, employeeData.message);
                let message = employeeData && employeeData.message !== undefined ? employeeData.message : "Problem Fetching Records.";
                this.setState({ loading: false });
            }
        } catch (error) {
            console.log('error catch block', error);
            toastAlert("Please check Internet Connection.", "error");
            this.setState({ loading: false });
        }
    }

    componentDidMount() {
        this.getEmployeeData();
    }


    itemArray = () => {
        const { data } = this.state;
        const { location } = this.props;
        let stateData = location?.status?.label;
        return (
            [
                {
                    name: "Employees",
                    active: false,
                    link: "/employees"
                },
                {
                    name: "View Employee",
                    active: true,
                    link: ""
                }
            ]
        )
    }

    render() {
        const { data, loading, tabValue } = this.state;
        const handleChange = (event, newValue) => {
            this.setState({ tabValue: newValue });
        };
        return (
            <div>
                <Grid container>
                    <Grid item lg={12} sm={12} xs={12} md={12}>
                        {/* Breadcrumb-component : start */}
                        <BreadcrumbComp items={this.itemArray()} />
                        {/* Breadcrumb-component : end */}
                    </Grid>

                    {/* <Box sx={{ padding: 3 }}> */}
                        <Grid container spacing={2} sx={{ padding: 3 }}>
                            {/* Profile Section */}
                            <Grid item xs={12} md={5}>
                                <ProfileCard
                                    name={ data?.name }
                                    email={ data?.email }
                                    mobile={ data?.mobile }
                                    role={ data?.userId?.role }
                                    department={data?.department }
                                />
                            </Grid>

                            {/* Tab Section */}
                           
                        </Grid>
                    {/* </Box> */}
                </Grid>
            </div >
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.authReducer,
})

export default withRouter(connect(mapStateToProps)(EmployeeDetailComponent))